import * as service from './service'
export default {
  namespace: 'walletHelpBuyAccount',
  state: {
    helpBuyAccountData: {},
    accountRecordData: {}
  },
  effects: {
    * helpBuyAccount ({ payload }, { call, put }) {
      const res = yield call(service.helpBuyAccount, payload)
      yield put({
        type: 'save',
        payload: {
          helpBuyAccountData: res.data.data
        }
      })
      return res.data
    },
    * accountRecord ({ payload }, { call, put }) {
      const res = yield call(service.accountRecord, payload)
      yield put({
        type: 'save',
        payload: {
          accountRecordData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
